import styles from './ProgressIndicator.module.css';

export interface ProgressIndicatorProps {
  completed: number;
  total: number;
  currentFile?: string | undefined;
  indeterminate?: boolean;
}

export function ProgressIndicator({
  completed,
  total,
  currentFile,
  indeterminate = false,
}: ProgressIndicatorProps) {
  const percentage = total > 0 ? (completed / total) * 100 : 0;

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <span className={styles.label}>Converting files...</span>
        <span className={styles.count}>{completed} / {total} ({Math.round(percentage)}%)</span>
      </div>
      <div className={styles.track} role="progressbar" aria-valuenow={percentage} aria-valuemin={0} aria-valuemax={100}>
        <div
          className={`${styles.fill} ${indeterminate ? styles.indeterminate : ''}`}
          style={indeterminate ? undefined : { width: `${percentage}%` }}
        />
      </div>
      {currentFile && (
        <p className={styles.current}>Processing: {currentFile}</p>
      )}
    </div>
  );
}

export default ProgressIndicator;
